(function () {
    'use strict';

    angular
        .module('blocks.directives')
        .directive('spHelpText', spHelpText);

    spHelpText.$inject = ['$state', 'helpTextFactory', '$compile' ];
    /* @ngInject */
    function spHelpText($state, helpTextFactory, $compile) {
        var directive = {
            restrict: 'A',
            link: link,
            scope: { 
                'helpTextField': '@',
                'showAsIcon': '@',
                'popoverPlacement': '@'
            }
        };

        return directive;

        function link(scope, element, attrs) {
            helpTextFactory.helpTextData().then(function (data) {
                
                 if (data) {
                     
                     var state = $state.current.name;
                     var _showAsIcon = false;
                     var field;
                     if (element[0].tagName === "LABEL") {
                         _showAsIcon = true;
                         field = attrs["for"]
                     }
                     else {
                         field = scope.helpTextField;
                     }

                     if (scope.showAsIcon) {
                         _showAsIcon = true;
                     }

                     if (!scope.popoverPlacement) {
                         scope.popoverPlacement = "top";
                         
                     }
                     
                    for (var i = 0; i < data.length; i++) {
                        var d = data[i];
                        if (d.State === state && d.FieldName == field || d.State === "dailysetup" && d.FieldName == field) {
                            if (_showAsIcon) {
                                var escaped = d.HelpText.replace(new RegExp(/\"/g), "&quot;");
                                escaped = escaped.replace(new RegExp(/'/g), "\\'");
                                var ico = $compile("<a uib-popover-html=\"'" + escaped + "'\" popover-trigger=\"'outsideClick'\" popover-class=\"popOverHelp\" popover-placement=\"" + scope.popoverPlacement + "\" href='#'><i class='fa fa-question fa-1-5x helpColor' aria-label='open help'></i></a>")(scope);
                                element.append("&nbsp;");
                                element.append(ico);
                            }
                            else {
                                element.html(d.HelpText);
                            }
                            
                        }
                    }
                }
             }, function (error) { });
           
        }
    }
})();
